// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Edit Content Page Styles */
.edit-content-main {
  min-height: calc(100vh - 140px);
  background-color: #f8f9fa;
  padding: 20px 0;
}

.edit-content-layout {
  display: flex;
  gap: 30px;
  max-width: 1400px;
  margin: 0 auto;
}

/* Left Sidebar */
.edit-sidebar {
  width: 280px;
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: fit-content;
  position: sticky;
  top: 20px;
}

.edit-sidebar h3 {
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  border-bottom: 2px solid #00a0e3;
  padding-bottom: 8px;
}

.section-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.section-btn {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: none;
  background: transparent;
  border-radius: 8px;
  text-align: left;
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.section-btn:hover {
  background-color: #f0f8ff;
  color: #00a0e3;
}

.section-btn.active {
  background-color: #00a0e3;
  color: white;
}

.section-btn i {
  font-size: 16px;
  width: 16px;
}

/* Main Edit Area */
.edit-main-area {
  flex: 1 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.edit-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 30px;
  border-bottom: 1px solid #e9ecef;
  background: #fafbfc;
}

.edit-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
}

.edit-actions {
  display: flex;
  gap: 12px;
}

.btn-primary, .btn-secondary {
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.btn-primary {
  background-color: #00a0e3;
  color: white;
}

.btn-primary:hover {
  background-color: #0081b8;
}

.btn-secondary {
  background-color: transparent;
  color: #666;
  border: 1px solid #ddd;
}

.btn-secondary:hover {
  background-color: #f8f9fa;
}

/* Edit Content Area */
.edit-content-area {
  padding: 30px;
}

.edit-section {
  max-width: 800px;
}

.form-group {
  margin-bottom: 24px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
  font-size: 14px;
}

.form-control {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s ease;
  font-family: inherit;
}

.form-control:focus {
  outline: none;
  border-color: #00a0e3;
  box-shadow: 0 0 0 3px rgba(0, 160, 227, 0.1);
}

textarea.form-control {
  resize: vertical;
  min-height: 100px;
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.checkbox-group input[type="checkbox"] {
  width: 16px;
  height: 16px;
}

.checkbox-group label {
  margin: 0;
  font-weight: normal;
  cursor: pointer;
}

/* File Upload */
.file-upload {
  position: relative;
}

.file-upload input[type="file"] {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.file-upload-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background-color: #f8f9fa;
  border: 2px dashed #ddd;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  color: #666;
}

.file-upload-label:hover {
  border-color: #00a0e3;
  background-color: #f0f8ff;
  color: #00a0e3;
}

/* Applications List */
.applications-list, .content-list {
  width: 100%;
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e9ecef;
}

.list-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
}

.btn-add {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background-color: #00a0e3;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-add:hover {
  background-color: #0081b8;
}

.app-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.app-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
}

.app-info {
  flex: 1 1;
  display: flex;
  gap: 12px;
}

.app-info .form-control {
  margin-bottom: 0;
}

.app-actions {
  display: flex;
  gap: 8px;
}

.btn-icon {
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.btn-edit {
  background-color: #e3f2fd;
  color: #1976d2;
}

.btn-edit:hover {
  background-color: #bbdefb;
}

.btn-delete {
  background-color: #ffebee;
  color: #d32f2f;
}

.btn-delete:hover {
  background-color: #ffcdd2;
}

/* Page Title in Header */
.page-title {
  flex: 1 1;
  text-align: center;
}

.page-title h1 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .edit-content-layout {
    flex-direction: column;
    gap: 20px;
  }
  
  .edit-sidebar {
    width: 100%;
    position: static;
  }
  
  .section-nav {
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  .section-btn {
    flex: 1 1;
    min-width: 150px;
  }
}

@media (max-width: 768px) {
  .edit-content-main {
    padding: 10px 0;
  }
  
  .edit-header {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .edit-actions {
    justify-content: center;
  }
  
  .edit-content-area {
    padding: 20px;
  }
  
  .app-item {
    flex-direction: column;
    align-items: stretch;
  }
  
  .app-info {
    flex-direction: column;
  }
  
  .app-actions {
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/EditContent.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,SAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":["/* Edit Content Page Styles */\n.edit-content-main {\n  min-height: calc(100vh - 140px);\n  background-color: #f8f9fa;\n  padding: 20px 0;\n}\n\n.edit-content-layout {\n  display: flex;\n  gap: 30px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n/* Left Sidebar */\n.edit-sidebar {\n  width: 280px;\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  height: fit-content;\n  position: sticky;\n  top: 20px;\n}\n\n.edit-sidebar h3 {\n  margin: 0 0 20px 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a1a1a;\n  border-bottom: 2px solid #00a0e3;\n  padding-bottom: 8px;\n}\n\n.section-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.section-btn {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  text-align: left;\n  font-size: 14px;\n  color: #666;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.section-btn:hover {\n  background-color: #f0f8ff;\n  color: #00a0e3;\n}\n\n.section-btn.active {\n  background-color: #00a0e3;\n  color: white;\n}\n\n.section-btn i {\n  font-size: 16px;\n  width: 16px;\n}\n\n/* Main Edit Area */\n.edit-main-area {\n  flex: 1;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n}\n\n.edit-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 30px;\n  border-bottom: 1px solid #e9ecef;\n  background: #fafbfc;\n}\n\n.edit-header h2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.edit-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.btn-primary, .btn-secondary {\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.btn-primary {\n  background-color: #00a0e3;\n  color: white;\n}\n\n.btn-primary:hover {\n  background-color: #0081b8;\n}\n\n.btn-secondary {\n  background-color: transparent;\n  color: #666;\n  border: 1px solid #ddd;\n}\n\n.btn-secondary:hover {\n  background-color: #f8f9fa;\n}\n\n/* Edit Content Area */\n.edit-content-area {\n  padding: 30px;\n}\n\n.edit-section {\n  max-width: 800px;\n}\n\n.form-group {\n  margin-bottom: 24px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 500;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-control {\n  width: 100%;\n  padding: 12px 16px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.2s ease;\n  font-family: inherit;\n}\n\n.form-control:focus {\n  outline: none;\n  border-color: #00a0e3;\n  box-shadow: 0 0 0 3px rgba(0, 160, 227, 0.1);\n}\n\ntextarea.form-control {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.checkbox-group {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n}\n\n.checkbox-group label {\n  margin: 0;\n  font-weight: normal;\n  cursor: pointer;\n}\n\n/* File Upload */\n.file-upload {\n  position: relative;\n}\n\n.file-upload input[type=\"file\"] {\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n}\n\n.file-upload-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  background-color: #f8f9fa;\n  border: 2px dashed #ddd;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  color: #666;\n}\n\n.file-upload-label:hover {\n  border-color: #00a0e3;\n  background-color: #f0f8ff;\n  color: #00a0e3;\n}\n\n/* Applications List */\n.applications-list, .content-list {\n  width: 100%;\n}\n\n.list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.list-header h4 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n.btn-add {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background-color: #00a0e3;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.btn-add:hover {\n  background-color: #0081b8;\n}\n\n.app-items {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.app-item {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n}\n\n.app-info {\n  flex: 1;\n  display: flex;\n  gap: 12px;\n}\n\n.app-info .form-control {\n  margin-bottom: 0;\n}\n\n.app-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.btn-icon {\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.btn-edit {\n  background-color: #e3f2fd;\n  color: #1976d2;\n}\n\n.btn-edit:hover {\n  background-color: #bbdefb;\n}\n\n.btn-delete {\n  background-color: #ffebee;\n  color: #d32f2f;\n}\n\n.btn-delete:hover {\n  background-color: #ffcdd2;\n}\n\n/* Page Title in Header */\n.page-title {\n  flex: 1;\n  text-align: center;\n}\n\n.page-title h1 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #1a1a1a;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .edit-content-layout {\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .edit-sidebar {\n    width: 100%;\n    position: static;\n  }\n  \n  .section-nav {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n  \n  .section-btn {\n    flex: 1;\n    min-width: 150px;\n  }\n}\n\n@media (max-width: 768px) {\n  .edit-content-main {\n    padding: 10px 0;\n  }\n  \n  .edit-header {\n    flex-direction: column;\n    gap: 16px;\n    align-items: stretch;\n  }\n  \n  .edit-actions {\n    justify-content: center;\n  }\n  \n  .edit-content-area {\n    padding: 20px;\n  }\n  \n  .app-item {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  \n  .app-info {\n    flex-direction: column;\n  }\n  \n  .app-actions {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
